import { Component, Input, OnInit } from '@angular/core';
import { EventsInfo } from 'src/app/Models/MisEventos/eventsInfo';

@Component({
  selector: 'app-resumen-eventosmapa',
  templateUrl: './resumen-eventosmapa.component.html',
  styleUrls: ['./resumen-eventosmapa.component.css']
})
export class ResumenEventosmapaComponent implements OnInit {

  @Input()
  eventosMapa: EventsInfo;

  constructor() { }

  ngOnInit(): void{

  }
}
